import React from "react";
import { Col, Row } from "react-bootstrap";
import { Icons } from "../../atoms/Icons";

const DetailsComp = ({ data, itemIndex }) => {
  return (
    <Row className="details-comp-container text-start g-0">
      {data[itemIndex]?.details.map((item, index) => {
        return (
          <Col lg={6} key={index}>
            <Row>
              <Col xs={2}>
                <Icons
                  iconname={item.iconName}
                  variant={"icon-twenty-four-px"}
                />
              </Col>
              <Col xs={10}>
                <p className="details-title">{item.title}</p>
                <p className="details-description">{item.description}</p>
              </Col>
            </Row>
          </Col>
        );
      })}
    </Row>
  );
};

export default DetailsComp;
